import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@chakra-ui/react";
import { RESOLVE_MANUALLY } from "@/constants/routes";
import { IEmailAIExtractedData } from "@/types/common";
import { FieldData } from "../BaseTable";

const ResolveManuallyButton = ({
    reviewEmail
}:{
    reviewEmail: IEmailAIExtractedData
}) => {
    const navigate = useNavigate();

    return (
        <Button 
            colorPalette='cyan' 
            onClick={() =>
              navigate(RESOLVE_MANUALLY, {
                replace: true,
                state: {
                  reviewEmail,
                },
              })
            }
            >
            Resolve manually
        </Button>
    );
};

export default ResolveManuallyButton;
